import { Component, Input, Output, EventEmitter } from '@angular/core';

import { UI_DELIVERY_OPTIONS } from '../../../cart/constants/common';

@Component({
  standalone: false,
  selector: 'mobile-cart-footer',
  templateUrl: './mobile-cart-footer.component.html',
  styleUrls: ['./mobile-cart-footer.component.scss']
})
export class MobileCartFooterComponent {
  @Input() total: number;
  @Input() currency: string;
  @Input() delivery: any; // IPickupDelivery | IDeliveryToDoor;
  @Input() deliveryType: UI_DELIVERY_OPTIONS;

  @Output() onDeliveryEdit = new EventEmitter<void>();
  @Output() onShopMore = new EventEmitter<void>();
  @Output() onCheckout = new EventEmitter<void>();
  @Output() onClear = new EventEmitter<void>();

  public DELIVERY_OPTIONS = UI_DELIVERY_OPTIONS;
}
